<template>
    <div class="text-center col-button">
        <div v-html="button"></div>
    </div>
</template>

<script>
    let moment = require('moment-timezone');

    export default {
        name: "DatatableColRegister",

        props: {
            data: {},
            name: {},
            click: {},
            meta: {},
            classes: {},
        },

        computed: {
            button: function() {

                let startDate = this.data.start_date.split('T')[0]+' '+this.data.registration_details.onsite_reg_start;
                let endDate = this.data.end_date.split('T')[0]+' '+this.data.registration_details.onsite_reg_end;

                let startDateTime = moment.tz(startDate, this.data.timezone).format();
                let endDateTime = moment.tz(endDate, this.data.timezone).format();

                let preStart = moment.tz(this.data.registration_details.pre_reg_start.split('.')[0], this.data.timezone);
                let preEnd = moment.tz(this.data.registration_details.pre_reg_end.split('.')[0], this.data.timezone);

                let wwStart = moment.tz(this.data.registration_details.ww_early_reg_start.split('.')[0], this.data.timezone);
                let wwEnd = moment.tz(this.data.registration_details.ww_early_reg_end.split('.')[0], this.data.timezone);

                let clubStart = null;
                let clubEnd = null;

                if (
                    this.data.registration_details.club_early_reg_start != null &&
                    this.data.registration_details.club_early_reg_end != null
                ) {
                    clubStart = moment.tz(this.data.registration_details.club_early_reg_start.split('.')[0], this.data.timezone);
                    clubEnd = moment.tz(this.data.registration_details.club_early_reg_end.split('.')[0], this.data.timezone);
                }

                if (
                    this.data.registration_details.is_onsite_reg_available &&
                    moment().utc().isBetween(
                        moment(startDateTime).format('YYYY-MM-DD HH:mm:ss'),
                        moment(endDateTime).format('YYYY-MM-DD HH:mm:ss')
                    )
                ) {
                    return '<a href="/events/'+this.data.id+'/register" class="btn btn-info text-white text-uppercase">Register Onsite</a>';
                }
                else if (
                    (moment.utc().isBetween(preStart, preEnd)) ||
                    (moment.utc().isBetween(wwStart, wwEnd)) ||
                    moment.utc().isBetween(clubStart, clubEnd)
                ) {
                    return '<a href="/events/'+this.data.id+'/register" class="btn btn-info text-white text-uppercase">Register</a>';
                } else {
                    return '<button disabled class="btn btn-secondary disabled text-white text-uppercase ">Closed</button>';
                }

            }
        }
    }
</script>

<style scoped>

</style>
